export default Object.freeze({
  ExtraSmall: 2,
  Small: 4,
  Medium: 6,
  Large: 12,
});
